import { transform } from "lodash";

/**
 * Serialize an object into a query string.
 * Works similarly how Axios does it.
 * Using this instead of `URLSearchParams` to avoid encoding special characters.
 */
export const createQueryString = (params: Record<string, string>) => {
    return transform(
        params,
        (params, value, key) => {
            if (value !== null) {
                params.push(`${key}=${value}`);
            }
        },
        [] as string[],
    ).join("&");
};
